import styled from 'styled-components';

export const TextAlignInput = ({
  value,
  onChange,

  label,
}: {
  value?: string;
  onChange: (newValue?: string) => void;

  label?: string;
}) => {
  return (
    <Container>
      <label>{label}</label>

      <ButtonsContainer>
        <IconButton
          $active={value === 'left'}
          onClick={() => onChange(value === 'left' ? undefined : 'left')}
        >
          <i className="icon-align-left" />
        </IconButton>
        <IconButton
          $active={value === 'center'}
          onClick={() => onChange(value === 'center' ? undefined : 'center')}
        >
          <i className="icon-align-center" />
        </IconButton>
        <IconButton
          $active={value === 'right'}
          onClick={() => onChange(value === 'right' ? undefined : 'right')}
        >
          <i className="icon-align-right" />
        </IconButton>
        <IconButton
          $active={value === 'justify'}
          onClick={() => onChange(value === 'justify' ? undefined : 'justify')}
        >
          <i className="icon-align-justify" />
        </IconButton>
      </ButtonsContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 5px;
  padding-bottom: 10px;
  gap: 5px;

  label {
    padding-right: 10px;

    font-size: 11px;
    font-weight: 400;
    color: var(--text-color-secondary);

    white-space: nowrap;
  }
`;

const IconButton = styled.button<{ $active?: boolean }>`
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 5px;
  border: 1px solid var(--input-border-color);
  font-size: 12px;
  line-height: 14px;
  color: var(--text-color-secondary);

  &:hover {
    background-color: var(--panel-bg-color-hover);
  }

  ${({ $active }) =>
    $active &&
    'background-color: var(--panel-bg-color); color: var(--accent-color)'}
`;

const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  gap: 2px;
`;
